// extracted by mini-css-extract-plugin
module.exports = {"default":"styles_default__3qyb7"};